var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSystemSettingsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29117",
    "data-name": "Group 29117",
    transform: "translate(-397 -182)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13394",
    "data-name": "Rectangle 13394",
    width: 32,
    height: 32,
    transform: "translate(397 182)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(194 139)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 1.705,
    cy: 1.705,
    r: 1.705,
    transform: "translate(212.982 53.262)",
    fill: "none",
    stroke: "#8a8a8a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M234.823,71.057l.714-.508a1.183,1.183,0,0,1,.969-.151l.714-.508a.921.921,0,0,1,1.223.206l.715-.509a.921.921,0,0,1,1.223.206l2.39,3.361c.514.723.214,1.813.556,2.294l.3.417",
    transform: "translate(-14.623 -11.481)",
    fill: "none",
    stroke: "#8a8a8a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M231.977,71.528,229.541,68.1a.877.877,0,0,0-1.429,1.017l3.452,4.853a.67.67,0,0,1-.906.5l-1.209-.482c-1.132-.381-1.693.684-1.447,1.029,0,0,2.885,1.761,3.213,1.894a13.385,13.385,0,0,1,2.636,1.034l.913,1.284",
    transform: "translate(-10.716 -10.522)",
    fill: "none",
    stroke: "#8a8a8a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_7",
    "data-name": "Line 7",
    x2: 1.016,
    y2: 1.429,
    transform: "translate(221.921 58.917)",
    fill: "none",
    stroke: "#8a8a8a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_8",
    "data-name": "Line 8",
    x2: 0.762,
    y2: 1.072,
    transform: "translate(223.847 58.616)",
    fill: "none",
    stroke: "#8a8a8a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M219.712,56.65q.032-.1.061-.2l1.5-.263v-2.1l-1.5-.263a4.784,4.784,0,0,0-.427-1.034l.875-1.247-1.488-1.488-1.246.875a4.783,4.783,0,0,0-1.034-.427l-.263-1.5h-2.1l-.263,1.5a4.783,4.783,0,0,0-1.034.427l-1.247-.875-1.488,1.488.875,1.247a4.782,4.782,0,0,0-.427,1.034l-1.5.263v2.1l1.5.263a4.782,4.782,0,0,0,.427,1.034l-.875,1.246,1.488,1.488,1.247-.874a4.782,4.782,0,0,0,1.034.427l.263,1.5h2.1l.263-1.5q.151-.043.3-.095",
    fill: "none",
    stroke: "#8a8a8a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSystemSettingsIcon);
export default __webpack_public_path__ + "static/media/systemSettings_icon.a99f26d2.svg";
export { ForwardRef as ReactComponent };